<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Facture non conforme</div>
</div>
<div class="row col-12 w-100 mb-3">
    @if (step == 1) {
        <div class="bold-text">Choisissez la facture concernée :
            <select name="bill" class="custom-select w-auto" (change)="setSelectedBill($event)">
                @for (bill of bills; track bill) {
                    <option value="{{ bill.id }}">{{ bill.period }}
                        - {{ priceFormatService.getBillAmount(bill.totalTtc, bill.totalHt, bill.cusPenalityHt) }}
                    </option>
                }
            </select>
        </div>
    }
</div>

@if (step == 1) {
    <div class="row col-12 w-100">
        <div class="bold-text">Choisissez la ligne concernée :
            <select name="phoneNumber" class="custom-select w-auto" (change)="setSelectedLine($event)">
                @for (line of lines; track line) {
                    <option value="{{ line.phoneNumber }}"
                            [selected]="selectedLine == line">{{ line.phoneNumber }}{{ line.offerLabel ? ' - ' + line.offerLabel : '' }}
                    </option>
                }
            </select>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span></button>
            </div>
        </div>
    </div>
}

@if (step == 2) {
    <div class="col-12 w-100">
        <div class="row w-100 pb-2">
            <div class="w-100">Facture n° {{ bill.id }} de {{ bill.period }}
                - {{ priceFormatService.getBillAmount(bill.totalTtc, bill.totalHt, bill.cusPenalityHt) }}
            </div>
            <div class="w-100">
                Ligne: {{ selectedLine.phoneNumber }} {{ selectedLine.offerLabel ? ' - Forfait ' + selectedLine.offerLabel : null }}
            </div>
            <br><br>
            <div class="col-auto ml-1 w-100">
                <input type="radio" id="question1" class="form-check-input" name="motif" [(ngModel)]="motif"
                       value="Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois"/>
                <label class="form-check-label" for="question1">
                    Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois
                </label>
            </div>
            <div class="col-auto ml-1 w-100">
                <input type="radio" id="question2" class="form-check-input" name="motif" [(ngModel)]="motif"
                       value="Vous considérez que le prix facturé n'est pas conforme au contrat"/>
                <label class="form-check-label" for="question2">
                    Vous considérez que le prix facturé n'est pas conforme au contrat
                </label>
            </div>
            <div class="col-auto ml-1 w-100">
                <input type="radio" id="question3" class="form-check-input" name="motif" [(ngModel)]="motif"
                       value="Vous ne comprenez pas la facturation en hors-forfait d'une communication"/>
                <label class="form-check-label" for="question3">
                    Vous ne comprenez pas la facturation en hors-forfait d'une communication
                </label>
            </div>
            <div class="col-auto ml-1 w-100">
                <input type="radio" id="question4" class="form-check-input" name="motif" [(ngModel)]="motif"
                       value="Vous ne comprenez pas pourquoi vous avez été facturé alors que votre ligne est résiliée"/>
                <label class="form-check-label" for="question4">
                    Vous ne comprenez pas pourquoi vous avez été facturé alors que votre ligne est résiliée
                </label>
            </div>
            @if (bill.penalty) {
                <div class="col-auto ml-1 w-100">
                    <input type="radio" id="question5" class="form-check-input" name="motif" [(ngModel)]="motif"
                           value="Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées"/>
                    <label class="form-check-label" for="question5">
                        Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées
                    </label>
                </div>
            }
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(1)">Retour<span></span></button>
                @if (motif != null && ['Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois', 'Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées'].indexOf(motif) == -1) {
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(3)">Suivant<span></span>
                    </button>
                }
                @if (motif != null && ['Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois', 'Vous ne comprenez pas pourquoi des pénalités de retard ont été facturées'].indexOf(motif) !== -1) {
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}

@if (step == 3) {
    <div class="col-12 w-100">
        <div class="form-group">
            <div class="row w-100">Facture n° {{ bill.id }} de {{ bill.period }}
                - {{ priceFormatService.getBillAmount(bill.totalTtc, bill.totalHt, bill.cusPenalityHt) }}
            </div>
            <div class="row w-100">
                Ligne: {{ selectedLine.phoneNumber }} {{ selectedLine.offerLabel ? ' - Forfait ' + selectedLine.offerLabel : null }}
            </div>
            <div class="row w-100 bold-text">{{ motif }}</div>
            <!----------------------------------------------------------------------------------------------------------------->
            @if (motif == 'Vous ne comprenez pas la facturation en hors-forfait d\'une communication' && billGsmDetailsCopy.length > 0) {
                <div class="row pt-3">
                    <div class="bold-text w-100 mb-2">Choisissez la ou les communications concernées* :</div>
                    Recherche: <input type="text" class="form-control"
                                      placeholder="Date, Destinataire, Type(voix, SMS, internet ...), Prix"
                                      (keyup)="filter($event)">
                    @if (billGsmDetails.data.length > 0) {
                        <table class="table table-striped border-top-0 pb-2 mt-2">
                            <thead>
                            <tr>
                                <th class="text-center"></th>
                                <th class="text-center">Date</th>
                                <th class="text-center">Destinataire</th>
                                <th class="text-center">Type</th>
                                <th class="text-center">Prix TTC</th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (billGsmDetail of billGsmDetails.data; track billGsmDetail) {
                                    <tr>
                                        <td class="text-center"><input type="checkbox" value="{{ billGsmDetail.id }}"
                                                                       (change)="changeSelection($event)"
                                                                       [checked]="protestedCommunications.indexOf(billGsmDetail.id) !== -1">
                                        </td>
                                        <td class="text-center">{{ billGsmDetail.date }}</td>
                                        <td class="text-center">{{ billGsmDetail.bnum }}</td>
                                        <td class="text-center">{{ billGsmDetail.optionLabel }}</td>
                                        <td class="text-center">{{ billGsmDetail.priceTtc }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                    @if (billGsmDetails.totalItems > 5) {
                        <div>
                            <app-paginator></app-paginator>
                        </div>
                    }
                    @if (billGsmDetails.data.length == 0) {
                        <div class="error-message">
                            Aucune communication ne correspond à votre recherche.
                        </div>
                    }
                    <br>
                    @if (displayCommunicationError && billGsmDetailsCopy.length > 0) {
                        <small class="form-text error-message w-100">Merci de choisir au moins une
                            communication.</small>
                    }
                </div>
            }
            @if (motif == 'Vous ne comprenez pas la facturation en hors-forfait d\'une communication' && billGsmDetailsCopy.length == 0) {
                <div class="row pt-3">
                    Cette facture ne contient aucune communication hors-forfait pour la
                    ligne {{ selectedLine.phoneNumber }}.
                </div>
            }
            <!----------------------------------------------------------------------------------------------------------------->
            @if (motif == 'Vous ne comprenez pas pourquoi vous avez été facturé alors que votre ligne est résiliée') {
                <div class="row pb-2 pt-2">
                    @if (selectedLine.status !== 'Rétractée' && selectedLine.status !== 'Résiliée') {
                        <div class="w-100">
                            Nous n’avons reçu aucune demande de résiliation pour la ligne {{ selectedLine.phoneNumber }}
                            . <span class="blue">Pour résilier votre ligne, rendez-vous dans la rubrique Mes lignes > Gestion de ma ligne et cliquez sur "Résilier ma ligne".</span>
                            <br><br>
                            Si vous pensez avoir déjà résilié cette ligne, vous pouvez remplir le formulaire ci-dessous.
                            <br><br>
                        </div>
                    }
                    @if (selectedLine.status == 'Résiliée' && realTerminationLineDate !== null) {
                        <div class="w-100">
                            La ligne {{ selectedLine.phoneNumber }} a été résiliée
                            le {{ formattingDate(realTerminationLineDate) }}.
                            <br>
                            Prixtel ne facturant pas votre forfait à l'avance, <span class="blue">il est normal qu'une dernière facture et un dernier prélèvement soient émis début {{ getMonth(1, false) }}
                            . Ils portent sur vos consommations {{ getMonth(0, true) }}, qui est votre dernier mois d'abonnement.</span>
                            <br><br>
                            Si vous constatez un autre problème, vous pouvez remplir le formulaire ci-dessous.
                        </div>
                    }
                    @if (selectedLine.status == 'Rétractée' && realTerminationLineDate !== null) {
                        <div class="w-100">
                            La ligne {{ selectedLine.phoneNumber }} a été rétractée
                            le {{ formattingDate(selectedLine.retractionDate) }}.
                            <br>
                            <span class="blue">Si vous avez utilisé votre forfait avant de vous rétracter, il est normal qu’il vous soit facturé.</span>
                            <br><br>
                            Si vous constatez un autre problème, vous pouvez remplir le formulaire ci-dessous.
                        </div>
                    }
                    @if (['Rétractée', 'Résiliée'].indexOf(selectedLine.status) === -1) {
                        <div class="w-100">
                            <div class="w-100 bold-label-text pt-2">Date à laquelle vous pensez avoir résilié (Dans les
                                6 derniers mois)*
                            </div>
                            <mat-form-field>
                                @if (!terminationDateControl.touched) {
                                    <p class="datepicker-placeholder label">JJ/MM/AAAA</p>
                                }
                                <input matInput (dateChange)="setTerminationDate($event.value)"
                                       [formControl]="terminationDateControl" [min]="minDate" [max]="maxDate"
                                       [matDatepicker]="picker">
                                <mat-datepicker-toggle matSuffix [for]="picker">
                                    <mat-icon id="calendar-icon" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
                                </mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            @if (displayDateError && submitted) {
                                <div class="row w-100 ml-2 form-text error-message">Ce champ est invalide.</div>
                            }
                            @if (displayDateRangeError) {
                                <small class="form-text error-message">La date saisie doit être inférieure à 6
                                    mois.</small>
                            }
                        </div>
                    }
                </div>
            }
            <!----------------------------------------------------------------------------------------------------------------->
            @if (!firstLastMonthCase) {
                <div class="row w-100 mt-2">
                    Expliquez-nous votre demande de manière claire et concise afin que nous puissions y répondre au
                    mieux. N'hésitez pas à joindre un fichier si cela peut être utile à votre réclamation.
                    <br><br>
                    <span class="bold-label-text">Détail de votre demande*</span>
                    <textarea class="form-control w-100" rows="20" (change)="checkDetailEmpty()" [(ngModel)]="details"
                              required></textarea>
                    @if (displayMessageError && details.length == 0) {
                        <small class="form-text error-message">Ce champ est obligatoire.</small>
                    }
                    @if (displayMessageError && details.length !== 0 && (details.length < 20 || details.length > 1000)) {
                        <small class="form-text error-message">Votre message doit contenir entre 20 et 1000
                            caractères.</small>
                    }
                </div>
            }
            <br>
            @if (!firstLastMonthCase) {
                <div class="row">
                    <span class="bold-label-text float-left mb-1">Justificatif :</span>
                    <span class="btn btn-file ml-2">Parcourir <input type="file"
                                                                     accept="image/jpeg,image/jpg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                                                     (change)="getFile($event)"></span>
                    @if (fileNameDisplay) {
                        <span>{{ fileNameDisplay }}</span>
                    }
                </div>
            }
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(2)">Retour<span></span></button>
                @if (!firstLastMonthCase || this.motif == 'Vous ne comprenez pas pourquoi le premier et le dernier mois sont facturés comme les autres mois') {
                    <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                    </button>
                }
            </div>
        </div>
    </div>
}
